import { render, staticRenderFns } from "./twofactor.vue?vue&type=template&id=5cbe65e0"
import script from "./twofactor.vue?vue&type=script&lang=js"
export * from "./twofactor.vue?vue&type=script&lang=js"
import style0 from "./twofactor.vue?vue&type=style&index=0&id=5cbe65e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports